export interface FlyoutModel {
  flyoutVisible: boolean;
  flyoutId: FlyoutTemplate | null;
  flyoutParameters: FlyoutParameters;
}

export interface FlyoutParameters {
  // This Any is here because it support any flayout data
  [key: string]: any;
}

export enum FlyoutTemplate {
  PROFILE_VIEW = 'profileView',
  FILTER_VIEW = 'filterView',
}
